import { useState } from 'react'
import { TilledFormState } from '../../../elements/Tilled/TilledFormTypes'

export const useTilledFormState = (initialState: TilledFormState) => {
  const [state, setter] = useState<TilledFormState>(initialState)
  return [state, setter] as const
}
